import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Assets
import ClientLogo01 from "../../assets/img/clients/shopify-logo.webp";

export default function ClientSlider() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div>
      <Slider {...settings}>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo01} alt="Shopify Logo" />
        </LogoWrapper>
      </Slider>
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 100%;
  height: auto; /* Ensures the container adjusts to image size */
  display: flex;
  justify-content: center;
`;

const ImgStyle = styled.img`
  max-width: 30%; /* Ensures the image does not exceed container width */
  max-height: 100%; /* Ensures the image does not exceed container height */
  object-fit: contain; /* Maintains aspect ratio without cropping */
  padding: 5px; /* Adjust padding as needed */
  margin: 0 auto;
`;
